module.exports = __webpack_public_path__ + "static/img/binzhou-index.12a1b82b.jpg";